module.exports = __webpack_public_path__ + "img/fangdichan.59e8036b.png";